import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../../styles/slideshow-styles';
import Slide from '../Slide';
import SlideIndicator from '../SlideIndicator';
import AutoplayControl from '../AutoplayControl';
import buildSlides from './buildSlides';
import renderSlide from './renderSlide';

class Slideshow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      autoplay: true,
      currentIndex: 0,
      slides: buildSlides(this.props.cards),
      slideInterval: 10000
    }
  }

  setInterval = () => {
    this.interval = setInterval(() => {
        this.handleForward()
    }, this.state.slideInterval);
  }

  handleForward = () => {
    const { currentIndex, slides } = this.state;
    const nextSlide = () => {
      if(slides.length - 1 !== currentIndex) {
        return currentIndex + 1;
      } else {
        return 0;
      }
    }
    this.setState({
      currentIndex: nextSlide()
    })
  }

  handleGoToSlide = (index) => {
    this.setState({
      currentIndex: index
    })
  }

  handlePauseSlideshow = () => {
    clearInterval(this.interval)
    this.setState({
      autoplay: false
    })
  }

  handlePlaySlideshow = () => {
    this.handleForward();
    this.setInterval();
    this.setState({
      autoplay: true
    })
  }


  componentDidMount() {
    buildSlides(this.props.cards);
    this.setInterval();

  }
  componentDidUpdate(prevProps) {
    if(prevProps.cards !== this.props.cards) {
      const slides = buildSlides(this.props.cards);
      clearInterval(this.interval);
      this.setState({
        slides,
        currentIndex: 0
      })
      this.setInterval();
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const { handleGoToSlide, handlePlaySlideshow, handlePauseSlideshow } = this;
    const { autoplay, currentIndex, slides } = this.state;
    const { classes } = this.props;

    const slideProps = {
      slide: renderSlide(this.state)
    }
    const indicatorProps = {
      handleGoToSlide,
      handlePlaySlideshow,
      handlePauseSlideshow,
      autoplay,
      currentIndex,
      slides,
    }
    const autoplayControlProps = {
      autoplay,
      handlePlaySlideshow,
      handlePauseSlideshow,
    }

    return (
      <div className={classes.root}>
        <Slide {...slideProps}/>
        <div className={classes.indicatorContainer}>
          <SlideIndicator {...indicatorProps}/>
          <AutoplayControl {...autoplayControlProps}/>
        </div>
      </div>
    )
  }
}

Slideshow.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Slideshow);



// WEBPACK FOOTER //
// ./src/components/slideshow/Slideshow/Slideshow.js